import { render } from "./XIconSolidMessageSquareText.vue?vue&type=template&id=544707fc"
import script from "./XIconSolidMessageSquareText.vue?vue&type=script&lang=js"
export * from "./XIconSolidMessageSquareText.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidMessageSquareText.vue"]])

export default __exports__